<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="70%" persistent>
      <v-card class="rounded-lg">
        <v-divider></v-divider>
        <v-card-text class="pt-6 d-flex justify-space-between">
          <!-- <div v-html="Head"></div> -->
          <h2>{{ $t("dashboard.detail") }}</h2>
          <v-btn color="red" fab x-small dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-text>
        <v-data-table
          dense
          :headers="_header"
          :items="_detail"
          :loading="loading"
          loading-text="Loading... Please wait"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:[`item.DetailSend`]="{ item }">
            <v-btn color="info" small rounded @click="Fn_ViewDetail(item)">{{
              $t("consentlist.detail")
            }}</v-btn>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            <!-- <v-badge :color="getColor(item.Status)" dot>
              {{item.Status}}
            </v-badge> -->
            <v-chip
              v-if="item.Status === 'ยินยอม'"
              :color="getColor(item.Status)"
              class="my-1"
              >{{ $t("dashboard.statusapp") }}</v-chip
            >
            <v-chip
              v-else-if="item.Status === 'ปฏิเสธ'"
              :color="getColor(item.Status)"
              class="my-1"
              >{{ $t("dashboard.statusreject") }}</v-chip
            >
            <v-chip v-else :color="getColor(item.Status)" class="my-1">{{
              $t("dashboard.statuspen")
            }}</v-chip>
          </template>
        </v-data-table>
        <!-- <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()"> ปิด </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_header", "_detail"],
  data: function () {
    return {
      Head: "รายละเอียด",
      loading: true,
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    getColor(Status) {
      if (Status === "ยินยอม") return "teal lighten-5 teal--text";
      else if (Status === "ปฏิเสธ") return "red lighten-5 red--text";
      else return "orange lighten-5 orange--text";
    },
    loadtable() {
      setTimeout(() => (this.loading = false), 2000);
    },
    Fn_ViewDetail(val) {
      this.$router.push("/group-dashboard-detail");
      this.$store.dispatch("SET_DATA_GROUP_DASHBOARD", val);
    },
  },
  mounted() {
    this.loadtable();
  },
};
</script>
